(function($) {
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

    // toggle
    if ($(window).width() < 749) {
    $(function () {
        $('.footer__blocks-wrapper .footer-block__heading').click(function(e) {
        e.preventDefault();
        $(this).toggleClass("active").next().slideToggle();
        });
    });
    }

    $(document).ready(function() {
        // add target blank in custom menu link
        if ($('#HeaderDrawer-法人の方へ').length) {
            $('#HeaderDrawer-法人の方へ').attr('target', '_blank');
        }

        // close menu drawer 
    $('#HeaderDrawer-商品一覧').on('click', function(e) {
        $('#Details-menu-drawer-container').removeClass('menu-opening');
        $('.header__icon--menu').attr('aria-expanded', 'false');
        $('body').removeClass('overflow-hidden-tablet');
    });
    });

    //ページトップへ戻るボタンの処理
    $(function () {
        var topBtn = $('.jsPageTop');
        topBtn.hide();
        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                topBtn.fadeIn();
            } else {
                topBtn.fadeOut();
            }
            scrollHeight = $(document).height();
            scrollPosition = $(window).height() + $(window).scrollTop();
            footHeight = $("footer").innerHeight();
            var windowWidth = $(window).outerWidth();
            if (scrollHeight - scrollPosition <= footHeight) {
                if (windowWidth < 768) {
                    $('.jsPageTop').css({
                        "bottom": footHeight - 25,
                    });
                } else {
                    $(".jsPageTop").css({
                        "bottom": footHeight - 50,
                    });
                }
                $(".jsPageTop").css({
                    "position": "absolute",
                });
                $("body").css({
                    "position": "relative",
                });
            } else {
                if (windowWidth < 768) {
                    $('.jsPageTop').css({
                        "position": "fixed",
                        "bottom": 80,
                    });
                } else {
                    $(".jsPageTop").css({
                        "position": "fixed",
                        "bottom": 60,
                    });
                }
            }
        });
        topBtn.click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    });
})(jQuery);